/**
 * How long since `since`, at `now` (milliseconds), in kubectl's compact
 * notation, to the minute or the second: « 47s », « 14m32s », « 2h14m »,
 * « 3d4h12m ». The same text in every language, as kubectl's AGE column —
 * the exact date goes in the caller's tooltip. Used for a pod's age (the
 * branch page's pods card) and a node's uptime (the home page's platform
 * card). A `since` after `now` (clock skew) reads « 0s ».
 */
export function compactDuration(since: number, now: number): string {
  const seconds = Math.max(0, Math.floor((now - since) / 1000));
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  if (days > 0) {
    return `${days}d${hours % 24}h${minutes % 60}m`;
  }
  if (hours > 0) {
    return `${hours}h${minutes % 60}m`;
  }
  if (minutes > 0) {
    return `${minutes}m${seconds % 60}s`;
  }
  return `${seconds}s`;
}
